const GENERAL_INFO_MODAL_ID = "general-info-modal";
const GENERAL_INFO_MODAL_STORAGE_KEY = "general_info_modal_updated_at";
class Modal {
    constructor() {
        this.init();
    }

    init() {
        this.initGeneralInfoModal();

        let modals = document.querySelectorAll(".modal-open");
        modals.forEach(modal => {
            modal.addEventListener("click", event =>
                this.handleModalClick(event, modal)
            );
        });

        const overlays = document.querySelectorAll(".modal-overlay");
        overlays.forEach(overlay => {
            overlay.addEventListener("click", this.toggle.bind(this));
        });

        var closemodals = document.querySelectorAll(".modal-close");
        closemodals.forEach(closemodal => {
            closemodal.addEventListener("click", this.toggle.bind(this));
        });

        document.addEventListener("keydown", this.handleKeyDown.bind(this));
    }

    initGeneralInfoModal() {
        const generalInfoModal = document.querySelector(
            "#" + GENERAL_INFO_MODAL_ID
        );

        if (generalInfoModal === null) {
            return;
        }

        const attributeTimestamp = generalInfoModal.getAttribute(
            "data-updated-at"
        );
        const storageTimestamp = localStorage.getItem(
            GENERAL_INFO_MODAL_STORAGE_KEY
        );

        if (!storageTimestamp || attributeTimestamp > storageTimestamp) {
            this.toggle(null, GENERAL_INFO_MODAL_ID);
        }
    }

    handleModalClick(event, modal) {
        event.preventDefault();
        this.toggle(event, modal.getAttribute("data-modal"));
    }

    handleKeyDown(event) {
        event = event || window.event;
        var isEscape = false;
        if ("key" in event) {
            isEscape = event.key === "Escape" || event.key === "Esc";
        } else {
            isEscape = event.keyCode === 27;
        }
        if (isEscape && document.body.classList.contains("modal-active")) {
            this.toggle();
        }
    }

    toggle(event, modalId = null) {
        if (modalId !== null) {
            const modal = document.querySelector("#" + modalId + ".modal");

            modal.classList.remove("opacity-0");
            modal.classList.remove("pointer-events-none");
            modal.classList.add("overflow-y-auto");
        } else {
            console.log("close all");

            const modals = document.querySelectorAll(".modal");

            modals.forEach(function(modal) {
                if (modal.id === GENERAL_INFO_MODAL_ID) {
                    localStorage.setItem(
                        GENERAL_INFO_MODAL_STORAGE_KEY,
                        modal.getAttribute("data-updated-at")
                    );
                }

                modal.classList.add("opacity-0");
                modal.classList.add("pointer-events-none");
                modal.classList.remove("overflow-y-auto");
            });
        }

        document.querySelector("body").classList.toggle("modal-active");
    }
}

export default Modal;
